/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanKind {
  PRO_10_MONTHLY = 'pro-10-monthly',
  PRO_10_ANNUALLY = 'pro-10-annually',
  PRO_30_MONTHLY = 'pro-30-monthly',
  PRO_30_ANNUALLY = 'pro-30-annually',
  MAX_05_MONTHLY = 'max-05-monthly',
  MAX_05_ANNUALLY = 'max-05-annually',
  MAX_10_MONTHLY = 'max-10-monthly',
  MAX_10_ANNUALLY = 'max-10-annually',
  MAX_20_MONTHLY = 'max-20-monthly',
  MAX_20_ANNUALLY = 'max-20-annually',
  MAX_30_MONTHLY = 'max-30-monthly',
  MAX_30_ANNUALLY = 'max-30-annually',
  BUSINESS_10_MONTHLY = 'business-10-monthly',
  BUSINESS_10_ANNUALLY = 'business-10-annually',
  BUSINESS_20_MONTHLY = 'business-20-monthly',
  BUSINESS_20_ANNUALLY = 'business-20-annually',
  BUSINESS_30_MONTHLY = 'business-30-monthly',
  BUSINESS_30_ANNUALLY = 'business-30-annually',
  PRO_MONTHLY = 'pro-monthly',
  PRO_ANNUALLY = 'pro-annually',
  ULTRA_MONTHLY = 'ultra-monthly',
  ULTRA_ANNUALLY = 'ultra-annually',
  STANDARD_MONTHLY = 'standard-monthly',
  STANDARD_ANNUALLY = 'standard-annually',
  SUPERNINJA_ULTRA_MONTHLY_10 = 'superninja-ultra-monthly-10',
  SUPERNINJA_ULTRA_MONTHLY_20 = 'superninja-ultra-monthly-20',
  SUPERNINJA_ULTRA_MONTHLY = 'superninja-ultra-monthly',
  SUPERNINJA_ULTRA_ANNUALLY_10 = 'superninja-ultra-annually-10',
  SUPERNINJA_ULTRA_ANNUALLY_20 = 'superninja-ultra-annually-20',
  SUPERNINJA_ULTRA_ANNUALLY = 'superninja-ultra-annually',
  TEAMS_PRO_MONTHLY = 'teams-pro-monthly',
  TEAMS_PRO_ANNUALLY = 'teams-pro-annually',
  TEAMS_ULTRA_MONTHLY = 'teams-ultra-monthly',
  TEAMS_ULTRA_ANNUALLY = 'teams-ultra-annually',
  TEAMS_SUPERNINJA_ULTRA_MONTHLY_10 = 'teams-superninja-ultra-monthly-10',
  TEAMS_SUPERNINJA_ULTRA_MONTHLY_20 = 'teams-superninja-ultra-monthly-20',
  TEAMS_SUPERNINJA_ULTRA_MONTHLY = 'teams-superninja-ultra-monthly',
  TEAMS_SUPERNINJA_ULTRA_ANNUALLY_10 = 'teams-superninja-ultra-annually-10',
  TEAMS_SUPERNINJA_ULTRA_ANNUALLY_20 = 'teams-superninja-ultra-annually-20',
  TEAMS_SUPERNINJA_ULTRA_ANNUALLY = 'teams-superninja-ultra-annually',
  TEAMS_STANDARD_MONTHLY = 'teams-standard-monthly',
  TEAMS_STANDARD_ANNUALLY = 'teams-standard-annually',
  CREDIT_1_MONTHLY = 'credit-1-monthly',
  CREDIT_1_ANNUALLY = 'credit-1-annually',
  CREDIT_5_MONTHLY = 'credit-5-monthly',
  CREDIT_5_ANNUALLY = 'credit-5-annually',
}
